<template>
    <v-col cols="12" class="mb-2">
        <v-divider>
            <i style="font-size:16px">
                <slot/>
            </i>
        </v-divider>
    </v-col>
</template>

<script>
export default {

}
</script>
